import { DistributorResponseItem } from "../../../common/api/catalogue-api/distributors/responses/GetDistributorsListResponse";

export interface DistributorListingItem {
    id: string;
    name: string;
    alias?: string;
    updatedDate: string;
    buzzId?: string;
    shreqId?: string;
    isModified: boolean;
}

export const mapToDistributorListingItem = (item: DistributorResponseItem): DistributorListingItem => {
    return {
        id: item.id,
        name: item.name,
        alias: item.alias,
        buzzId: item.buzzId,
        shreqId: item.shreqId,
        updatedDate: item.audit.updatedDate,
        isModified: false
    };
};
